import { render, staticRenderFns } from "./DeviceHelpSection.vue?vue&type=template&id=5c2c2650&scoped=true&"
import script from "./DeviceHelpSection.vue?vue&type=script&lang=ts&"
export * from "./DeviceHelpSection.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceHelpSection.vue?vue&type=style&index=0&id=5c2c2650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c2650",
  null
  
)

export default component.exports